<template>
    <v-container>
        <v-snackbar v-model="alert" timeout="5000" :color="alertType">
            {{ alertContent }}
        </v-snackbar>
        <v-card style="margin-bottom:10px">
            <v-card-title>
                {{$t('tzintukim')}}
            </v-card-title>
        </v-card>
        <v-data-table :headers="headers" :items="lists" :items-per-page="-1" class="elevation-1">
            <template v-slot:item.actions="{ item }">
                <v-btn icon @click="run(item)">
                    <v-icon>
                        mdi-play
                    </v-icon>
                </v-btn>
                <v-btn icon @click="show(item)">
                    <v-icon>
                        mdi-eye
                    </v-icon>
                </v-btn>
                <v-btn icon @click="log(item)">
                    <v-icon>
                        mdi-chart-box
                    </v-icon>
                </v-btn>
                <v-btn icon @click="reset(item)">
                    <v-icon>
                        mdi-restart
                    </v-icon>
                </v-btn>
            </template>
        </v-data-table>
    </v-container>
</template>
<script>
import axios from 'axios';
export default {
    data: () => ({
        lists: [

        ],
        alert: false,
        alertType: '',
        alertContent: '',
    }),
    computed: {
        headers () {
            return [
                {
                    text: this.$t('listName'),
                    align: 'start',
                    sortable: false,
                    value: 'listName'
                },
                { text: this.$t('subscribersCount'), value: 'subscribers' },
                { text: this.$t('actions'), value: 'actions', sortable: false },
            ]
        }
    },
    methods: {
        loadData () {
            (async () => {
                const body = { token: sessionStorage.token, action: "getlists" };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/TzintukimListManagement`, body);
                this.lists = response.data.lists;
            })();
        },
        run(item) {
            (async () => {
                const body = { token: sessionStorage.token, phones: `tzl:${item.listName}` };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/RunTzintuk`, body);
                if (response.data.responseStatus === "OK") {
                    this.alert = true;
                    this.alertType = "success";
                    this.alertContent = this.$t('tzintukRunSuccess')
                } else {
                    this.alert = true;
                    this.alertType = "red";
                    this.alertContent = this.$t('tzintukRunError')
                }
            })();
        },
        show(item) {
            this.$router.push(`/tzintuk/view/?list=${item.listName}`)
        },
        log(item) {
            this.$router.push(`/tzintuk/log/?list=${item.listName}`)
        },
        reset(item) {
            if (confirm(this.$t('resetTzintukListConfirm'))) {
                (async () => {
                const body = { token: sessionStorage.token, action: "resetList", TzintukimList: item.listName };
                const response = await axios.post(`https://${sessionStorage.server}.call2all.co.il/ym/api/TzintukimListManagement`, body);
                if (response.data.responseStatus === "OK") {
                    this.alert = true;
                    this.alertType = "success";
                    this.alertContent = this.$t('tzintukListResetSuccess')
                    this.loadData();
                } else {
                    this.alert = true;
                    this.alertType = "red";
                    this.alertContent = this.$t('error')
                }
                })();
            }
        },
    },
    beforeMount() {
        this.loadData();
    },
}
</script>